import { Link } from 'gatsby'
import styled from 'styled-components'

import { themeStyles, themeMedia } from '../../../styles/theme'
import { Text } from '../text'
import { StyledParagraph } from '../text/styles'
import { brandConfig } from '../../../config/brandConfig'

export const StyledTitleAndLinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  width: 100%;
  margin: 1em 0;

  ${themeMedia.desktop`
    margin: 2em 0;
  `}
`

export const StyledOuterWrapper = styled.div`
  color: ${themeStyles.colors.white.main};
  overflow: hidden;

  &:has(${Text}) ${StyledTitleAndLinkWrapper} {
    ${themeMedia.maxDesktop`
      margin: 1em 0 0.6em;
    `}
  }

  ${StyledParagraph} {
    margin-bottom: 0.8em;
  }
`

export const StyledShowAll = styled(Link)`
  color: ${themeStyles.colors.primary.main};
  text-decoration: none;
  text-align: right;
  font-size: ${brandConfig.fonts.text.paragraph.size.mobile};
  font-weight: 700;

  ${themeMedia.desktop`
    font-size: ${brandConfig.fonts.text.paragraph.size.desktop}
  `}
`
